<template>
  <div style="height: 100%">
    <el-table
      :data="tableData"
      height="100%"
      :border="true"
      :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
    >
      <el-table-column
        prop="tdc_name"
        align="center"
        min-width="120"
        label="城市仓"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="order_no"
        align="center"
        min-width="120"
        label="订单号"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="supplier_order_no"
        align="center"
        min-width="120"
        label="供货单编号"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="supplier_name" align="center" label="供应商名称">
      </el-table-column>
      <el-table-column prop="buyer_name" align="center" label="业务名称">
      </el-table-column>
      <el-table-column prop="sku_code" align="center" label="商品名称（货号）">
        <template slot-scope="scope">
          <div>{{ scope.row.title }}({{ scope.row.sku_code }})</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="supplier_create_time"
        align="center"
        label="供货单创建时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="order_create_time"
        align="center"
        label="订单创建时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="product_amt"
        align="center"
        label="商品总金额"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="aftersale_amt"
        align="center"
        label="售后总金额"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="qc_out_amt"
        align="center"
        label="缺货总金额"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="financial_fee"
        align="center"
        label="金融手续费(0.4%)"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="service_charges_fee"
        align="center"
        label="应收推广奖励"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="service_charges_fee_real"
        align="center"
        label="实际推广奖励"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="service_charges_fee_diff"
        align="center"
        label="差额"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="settlement_amt"
        align="center"
        label="结算金额"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "TableList",
  props: ["tableData"],
  data() {
    return {};
  },
  mounted() {},
  watch: {},

  methods: {},
};
</script>
<style lang="scss" scoped></style>
